<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [hasSearchInput]="showAccountFilters"
   [searchText]="searchText"
   [hideHeader]="true"
   [pagingCallState]="pagingCallState"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
   [pluralNameOverride]="'Queue History'"
>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource" class="queue-history-table">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         @if (showQueueColumn) {
         <ng-container lcsColumnDef="queueExtension" width="2">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="queueExtension-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'queueExtension.number')"
               sortField="queueExtension.number"
               >Queue<mat-icon class="mat-icon-sort">{{ getSort('queueExtension.number') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let queueHistory" (click)="onOpenCallDetailClick(queueHistory)">
               {{ getQueueDisplay(queueHistory) }}
            </td>
         </ng-container>
         }
         <ng-container lcsColumnDef="callerIdName" width="1.5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="callerIdName-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'callerIdName')"
               sortField="callerIdName"
               >Caller Id<mat-icon class="mat-icon-sort">{{ getSort('callerIdName') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let queueHistory" (click)="onOpenCallDetailClick(queueHistory)">
               {{ queueHistory.callerIdName }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callerIdNumber" width="1">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="callerIdNumber-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'callerIdNumber')"
               sortField="callerIdNumber"
               >Number<mat-icon class="mat-icon-sort">{{ getSort('callerIdNumber') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let queueHistory" (click)="onOpenCallDetailClick(queueHistory)">
               {{ queueHistory.callerIdNumber | formatPhoneNumbers }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callerStatus" width="1.5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="callerStatus-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'callerStatusDescription')"
               sortField="callerStatusDescription"
               >Status<mat-icon class="mat-icon-sort">{{ getSort('callerStatusDescription') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let queueHistory" (click)="onOpenCallDetailClick(queueHistory)">
               {{ queueHistory.callerStatus | addSpaces }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="agentExtension" width="1.5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="agentExtension-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'agentExtensionNumber')"
               sortField="agentExtensionNumber"
               >Agent<mat-icon class="mat-icon-sort">{{ getSort('agentExtensionNumber') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let queueHistory" (click)="onOpenCallDetailClick(queueHistory)">
               {{
                  queueHistory.agentExtension?.name && queueHistory.agentExtension?.number
                     ? queueHistory.agentExtension.name + ' (' + queueHistory.agentExtension.number + ')'
                     : ''
               }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="enqueuedDateTime" width="1.5">
            <th
               class="header-align-right"
               lcs-header-cell
               *lcsHeaderCellDef
               id="enqueuedDateTime-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'enqueuedDateTime')"
               sortField="enqueuedDateTime"
               >Since<mat-icon class="mat-icon-sort">{{ getSort('enqueuedDateTime') }}</mat-icon></th
            >
            <td
               class="text-align-right"
               lcs-cell
               *lcsCellDef="let queueHistory"
               (click)="onOpenCallDetailClick(queueHistory)"
            >
               {{ queueHistory.enqueuedDateTime | date : 'hh:mm aa' }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="order" width="2">
            <th
               class="header-align-right"
               lcs-header-cell
               *lcsHeaderCellDef
               id="order-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'enqueuedDateTime')"
               sortField="enqueuedDateTime"
               >Wait Order<mat-icon class="mat-icon-sort">{{ getSort('enqueuedDateTime') }}</mat-icon></th
            >
            <td
               class="text-align-right"
               lcs-cell
               *lcsCellDef="let queueHistory"
               (click)="onOpenCallDetailClick(queueHistory)"
            >
               {{ getQueueOrder(queueHistory) }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="isCallbackRequested" width="1">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="isCallbackRequested-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'isCallbackRequested')"
               sortField="isCallbackRequested"
               >Callback<mat-icon class="mat-icon-sort">{{ getSort('isCallbackRequested') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let queueHistory" (click)="onOpenCallDetailClick(queueHistory)">
               @if (queueHistory.isCallbackRequested) {
               <mat-icon>check</mat-icon>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callbackAttempts" width="2">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="callbackAttempts-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'callbackAttempts')"
               sortField="callbackAttempts"
               >Callback Attempts<mat-icon class="mat-icon-sort">{{ getSort('callbackAttempts') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let queueHistory" (click)="onOpenCallDetailClick(queueHistory)">
               {{ queueHistory.callbackAttempts }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="waitTime" width="1.5">
            <th
               class="header-align-right"
               lcs-header-cell
               *lcsHeaderCellDef
               id="waitTime-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'waitTime')"
               sortField="waitTime"
               >Wait Time<mat-icon class="mat-icon-sort">{{ getSort('waitTime') }}</mat-icon></th
            >
            <td
               class="text-align-right"
               lcs-cell
               *lcsCellDef="let queueHistory"
               (click)="onOpenCallDetailClick(queueHistory)"
            >
               {{ getWaitTimeDisplay(queueHistory) }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="queueHistoryActionsMenu" width="0.5">
            <th lcs-header-cell *lcsHeaderCellDef id="menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let queueHistory">
               <button
                  type="button"
                  aria-label="Queue History Row Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="queueHistoryMenu"
                  id="queue-history-action"
               >
                  <mat-icon>more_horiz</mat-icon>
               </button>
               <mat-menu #queueHistoryMenu="matMenu">
                  @if (hangupActiveCallsPrivileges.enabled) {
                  <button mat-menu-item (click)="onClearClick(queueHistory)">Clear Call</button>
                  } @if (canOpenCallDetails(queueHistory)) {
                  <button mat-menu-item (click)="onOpenCallDetailClick(queueHistory)">Details</button>
                  }
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
